import { render } from "./input-prev-reg.vue?vue&type=template&id=c9ebf8b0&scoped=true&ts=true"
import script from "./input-prev-reg.vue?vue&type=script&lang=ts"
export * from "./input-prev-reg.vue?vue&type=script&lang=ts"

import "./input-prev-reg.vue?vue&type=style&index=0&id=c9ebf8b0&scoped=true&lang=css"

import exportComponent from "C:\\agent\\_work\\44\\s\\DesignReg.VueClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9ebf8b0"]])

export default __exports__